export const SESSION_STORE_KEY = '_dd_s_v2';
export const LEGACY_SESSION_STORE_KEY = '_dd_s';
//# sourceMappingURL=sessionStoreStrategy.js.map